import { BaseBannerSerializer } from './BaseBannerSerializer';

class MainBannerSerializer {
  static deSerialize(data) {
    return BaseBannerSerializer.deSerialize(data);
  }
}

export { MainBannerSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/MainBannerSerializer.js